import script from "./GdvAccessListItemComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./GdvAccessListItemComponent.vue?vue&type=script&setup=true&lang=ts"

import "./GdvAccessListItemComponent.vue?vue&type=style&index=0&id=32988b2f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32988b2f"]])

export default __exports__